import * as MixpanelProfilePageActions from '@analytics/mixpanel/actions/ProfilePage';
import { formatPrice } from '@common/utils';
import Routes from '@constants/routes';
import { useYela } from '@hooks/useYela';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { ACTION_BUTTON, DURATION, DURATION_VALUE, I18N_PROFILE_CONTEXT, RESPONDS_IN, RESPONDS_IN_VALUE } from '../ProfileForm.constants';
import { GetOrderButton, GetOrderContainer, GetOrderInfoItem, GetOrderInfoWrapper, InfoTitle, InfoValue } from './GetOrder.styles';
import { GetOrderProps } from './GetOrder.types';

export const GetOrder = ({ creatorSlug, messageType, pricing, user }: GetOrderProps): JSX.Element => {
  const router = useRouter();
  const [loading, setLoading] = useState<boolean>(false);
  const { language } = useYela();
  const userData = user;
  const { t } = useTranslation(I18N_PROFILE_CONTEXT);

  const onClick = async () => {
    if (loading) return;

    setLoading(true);
    MixpanelProfilePageActions.onGetMessageClicked({
      router,
      details: { messageType: messageType, celebrityName: creatorSlug, price: `${pricing.currencySymbol}${pricing.price}` },
    });

    if (userData) {
      await router.push(Routes.BOOKING(creatorSlug, messageType));
    } else {
      await router.push(Routes.REGISTER + `?creator=${creatorSlug}&action=booking&type=${messageType}`);
    }
  };

  return (
    <GetOrderContainer>
      <GetOrderInfoWrapper>
        <GetOrderInfoItem>
          <InfoTitle>{t(DURATION)}</InfoTitle>
          <InfoValue>{t(DURATION_VALUE)}</InfoValue>
        </GetOrderInfoItem>
        <GetOrderInfoItem>
          <InfoTitle>{t(RESPONDS_IN)}</InfoTitle>
          <InfoValue>{t(RESPONDS_IN_VALUE)}</InfoValue>
        </GetOrderInfoItem>
      </GetOrderInfoWrapper>
      <GetOrderButton
        text={
          language == 'en'
            ? t(ACTION_BUTTON(messageType)) +
              formatPrice({ currencyCode: pricing.currencyCode, currencySymbol: pricing.currencySymbol, value: pricing.price })
            : t(ACTION_BUTTON(messageType))
        }
        rounded
        uppercase
        onClick={onClick}
        loadingState={loading}
      />
    </GetOrderContainer>
  );
};
